module.exports = __webpack_public_path__ + "img/info.afa36505.svg";